"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchesProgram = void 0;
const sol_kit_1 = require("@raindrop-studios/sol-kit");
const MatchesInstruction = __importStar(require("../instructions/matches"));
const matches_1 = require("../constants/matches");
const programIds_1 = require("../constants/programIds");
const matches_2 = require("../state/matches");
class MatchesProgram extends sol_kit_1.Program.Program {
    constructor() {
        super();
        this.PROGRAM_ID = programIds_1.MATCHES_ID;
        this.instruction = new MatchesInstruction.Instruction({ program: this });
    }
    async fetchMatch(match) {
        const matchObj = await this.client.account.match.fetch(match);
        return new matches_2.Match(match, matchObj);
    }
    async fetchWinOracle(winOracle) {
        const winOracleObj = await this.client.account.winOracle.fetch(winOracle);
        return new matches_2.WinOracle(winOracle, winOracleObj);
    }
    async createMatch(args, options) {
        const ix = await this.instruction.createMatch(args);
        return await this.sendWithRetry(ix.instructions, ix.signers, options);
    }
    async joinMatch(args, accounts, additionalArgs, options) {
        const ix = await this.instruction.joinMatch(args, accounts, additionalArgs);
        return await this.sendWithRetry(ix.instructions, ix.signers, options);
    }
    async leaveMatch(args, accounts, additionalArgs, options) {
        const ix = await this.instruction.leaveMatch(args, accounts, additionalArgs);
        return await this.sendWithRetry(ix.instructions, ix.signers, options);
    }
    async drainMatch(accounts, additionalArgs, options) {
        const ix = await this.instruction.drainMatch({}, accounts, additionalArgs);
        return await this.sendWithRetry(ix.instructions, ix.signers, options);
    }
    async updateMatch(args, accounts, options) {
        const ix = await this.instruction.updateMatch(args, accounts, {});
        return await this.sendWithRetry(ix.instructions, ix.signers, options);
    }
    async updateMatchFromOracle(accounts, options) {
        const ix = await this.instruction.updateMatchFromOracle({}, accounts, {});
        return await this.sendWithRetry(ix.instructions, ix.signers, options);
    }
    async createOrUpdateOracle(args, options) {
        const ix = await this.instruction.createOrUpdateOracle(args);
        return await this.sendWithRetry(ix.instructions, ix.signers, options);
    }
    async drainOracle(args, accounts, options) {
        const ix = await this.instruction.drainOracle(args, accounts, {});
        return await this.sendWithRetry(ix.instructions, ix.signers, options);
    }
    async disburseTokensByOracle(args, accounts, additionalArgs, options) {
        const ix = await this.instruction.disburseTokensByOracle(args, accounts, additionalArgs);
        return await this.sendWithRetry(ix.instructions, ix.signers, options);
    }
}
exports.MatchesProgram = MatchesProgram;
MatchesProgram.PREFIX = matches_1.PREFIX;
